import { Content, Flex, Heading, IllustratedMessage } from '@adobe/react-spectrum';
import NotFound from '@spectrum-icons/illustrations/NotFound';
import React from 'react';

const NotFoundPage = () => {
  return (
    <Flex width="100%" height="100%" direction="column" justifyContent="center" alignItems="center" minHeight="70vh">
      <IllustratedMessage>
        <NotFound />
        <Heading>Error 404: Page not found</Heading>
        <Content>This page isn't available. Try checking the URL or visit a different page.</Content>
      </IllustratedMessage>
    </Flex>
  );
};

export default NotFoundPage;
